export function domainUrl() {
  // if (process.env.NODE_ENV === "development") return "http://localhost:3015";
  if (process.env.NODE_ENV === "development") return "https://ccim.test";

  return window.location.origin;
}

export function apiWebV1Url() {
  return `${domainUrl()}/api/web/v1`;
}
